import { McpToolCatalogParameter } from '@commenda/api';

import { TMapping } from '@commenda/types';

export class WorkflowToolCallHelper {
  /**
   * Required arguments the step has not mapped. Mirrors ToolCallStepValidator on the backend, which also sees
   * only schema-level requiredness — a tool's "one of these groups" rule lives in its prose and is caught at
   * run time, not here.
   */
  static findMissingArguments(
    parameters: Readonly<McpToolCatalogParameter[]>,
    inputMapping: Readonly<TMapping[]>
  ): string[] {
    const mapped = new Set(
      inputMapping.map((mapping) => mapping.targetPath?.split('.')[0])
    );

    return parameters
      .filter((parameter) => parameter.required && !mapped.has(parameter.name))
      .map((parameter) => parameter.name);
  }

  /** Arguments the schema marks required unconditionally. */
  static findAlwaysRequiredArguments(
    parameters: Readonly<McpToolCatalogParameter[]>
  ): string[] {
    return parameters
      .filter((parameter) => parameter.required)
      .map((parameter) => parameter.name);
  }

  static describeArguments(
    parameters: Readonly<McpToolCatalogParameter[]>
  ): string {
    if (parameters.length === 0) return 'no arguments';
    return parameters.map((parameter) => parameter.name).join(', ');
  }
}
